export default __webpack_public_path__ + "static/PaymentSection_it-376c8f4b1daee6002c104c8b5079225c.png";